// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__YeXIF","image":"Avatar_image__yRvyj","default":"Avatar_default__jYjZi","link":"Avatar_link__PdAtR"};